import { useTranslation } from '@fareye/common'
import { Flex, Label, Span, Card } from '@fareye/ui'
import {
  formatMs,
  getColorAfterComparing,
  FaTruckMoving,
  FaSubway,
  FaPlane,
  FaShip,
  isEmpty
} from '@fareye/utils'
import queryString from 'query-string'
import React from 'react'
import { labelColor } from '../../../config/colors'
import { inTransitConstant } from '../../../config/constants'
import { Status, StatusSlider } from '../../../style/styled'
import { IRouteWiseDetails } from '../../../utility/types'

const modeIcons: any = {
  road: FaTruckMoving,
  ocean: FaShip,
  rail: FaSubway,
  air: FaPlane
}

const RouteWiseDetails = (props: IRouteWiseDetails) => {
  const {
    config,
    origin,
    endDate,
    history,
    location,
    startDate,
    totalTrips,
    destination,
    vehicleMetrics,
    actualTransitTime,
    metrics,
    targetTransitTime,
    transportMode = [],
    route_string
  } = props
  const { styling } = config
  const { style, className, variant } = styling
  const { metricsCount, links } = config.config
  const metricsData = vehicleMetrics ? vehicleMetrics : metrics
  const routeLabel = route_string
    ? route_string.toUpperCase()
    : `${origin ? origin.toUpperCase() : ''} - ${
        destination ? destination.toUpperCase() : ''
      }`
  const updateURL = () => {
    const query = queryString.parse(location.search)
    const pathname = `${links.routeDetailPage}/${encodeURIComponent(
      `${route_string ? route_string : `${origin}-${destination}`}`
    )}`
    const search = queryString.stringify({
      ...query,
      startDate,
      endDate,
      transportMode: !isEmpty(transportMode) ? transportMode[0] : '',
      stops: metrics?.stops || ''
    })
    history.push({
      pathname,
      search
    })
  }

  const { t } = useTranslation()
  function calculatePercentage(
    actualTransitTime: any,
    targetTransitTime: any,
    flag: any
  ) {
    let percentage
    if (!flag) {
      percentage =
        actualTransitTime < targetTransitTime
          ? 100
          : Math.floor((targetTransitTime / actualTransitTime) * 100)
    } else {
      percentage =
        actualTransitTime > targetTransitTime
          ? 100
          : Math.floor((actualTransitTime / targetTransitTime) * 100)
    }
    if (percentage > 100) {
      percentage = 100
    }
    return percentage
  }
  return (
    <Card variant={variant.cardSize} style={{ cursor: 'pointer', ...style }}>
      <Flex column className={className} onClick={() => updateURL()}>
        <Flex column p={1}>
          <Flex justifyContentSpaceBetween>
            <Label variant="ellipsis" style={{ fontSize: '18px' }}>
              {routeLabel}
            </Label>
            {!isEmpty(transportMode) &&
              transportMode.map((key: any, index: number) => {
                const FaComponent = modeIcons[key]
                  ? modeIcons[key]
                  : modeIcons['road']
                return (
                  <FaComponent
                    size={18}
                    color={'#727272'}
                    style={{ marginRight: '4px' }}
                    key={key}
                  />
                )
              })}
          </Flex>
          <Span variant="secondary" style={{ marginTop: '5px' }}>
            {totalTrips} {t(inTransitConstant.tripsCount)}
          </Span>
        </Flex>
        {/* </Flex> */}
        <Flex justifyContentSpaceBetween>
          <Flex>
            {metricsCount?.map((metric: any, index: any) => (
              <Flex column p={1} key={metric.label}>
                <Label variant="h4 danger" style={{ color: metric.color }}>
                  {metricsData[metric.matchParam]
                    ? metricsData[metric.matchParam]
                    : 0}
                </Label>
                <Span style={{ whiteSpace: 'nowrap' }} variant="secondary">
                  {t(metric.label)}
                </Span>
              </Flex>
            ))}
          </Flex>
          <Flex alignItemsFlexEnd column p={1}>
            <Label
              p={1}
              variant="l"
              style={{
                color: `${
                  actualTransitTime > targetTransitTime ? '#D84343' : '#373737'
                }`,
                borderRadius: '2px',
                boxShadow: '0 0 1px 1px rgba(0,0,0,.1)',
                backgroundColor: '#F1F1F1'
              }}
            >
              {formatMs(actualTransitTime - targetTransitTime)}
            </Label>
            <Span
              variant="secondary xs"
              style={{
                textAlign: 'right',
                marginTop: '5px'
              }}
            >
              {t(inTransitConstant.timeDifference)}
            </Span>
          </Flex>
        </Flex>
      </Flex>
      <Flex column>
        <Flex p={1}>
          <Span
            style={{ fontSize: '12px', marginTop: 5 }}
            color={labelColor.normalText}
          >
            {t(inTransitConstant.transitTime)}
          </Span>
          <Span style={{ fontSize: '12px', marginTop: 5 }}>
            {`- ${formatMs(actualTransitTime)}`}
          </Span>
        </Flex>
        <StatusSlider>
          <Status
            percent={calculatePercentage(
              actualTransitTime,
              targetTransitTime,
              true
            )}
            color={getColorAfterComparing(actualTransitTime, targetTransitTime)}
          />
        </StatusSlider>
      </Flex>
      <Flex column>
        <StatusSlider>
          <Status
            percent={calculatePercentage(
              actualTransitTime,
              targetTransitTime,
              false
            )}
            color={{ block: '#A7A7A7' }}
          />
        </StatusSlider>
        <Flex p={1}>
          <Span style={{ fontSize: '12px' }} color={labelColor.normalText}>
            {t(inTransitConstant.target)}
          </Span>
          <Span style={{ fontSize: '12px' }}>
            {`- ${formatMs(targetTransitTime)}`}
          </Span>
        </Flex>
      </Flex>
    </Card>
  )
}

export default RouteWiseDetails
